<template>
  <div class="visit-chart">
    <canvas ref="chartCanvas">
    </canvas>
    <div v-if="percent.length > 0" class="percent">{{ percent }}%</div>
  </div>
</template>

<script>
import { Chart as ChartJS, DoughnutController, ArcElement, Tooltip, Legend, LinearScale, } from 'chart.js'

ChartJS.register(DoughnutController, ArcElement, Tooltip, Legend, LinearScale)

export default {
  name: 'VisitDonutChart',
  props: {
    labels: {
      required: true,
      type: Array,
    },
    data: {
      required: true,
      type: Array,
    },
    colors: {
      required: true,
      type: Array,
    },
    percent: { default: '', type: String, },
  },
  data() {
    return {
      chart: null,
    }
  },
  watch: {
    labels() {
      this.chart.data.labels = this.labels
      this.chart.update()
    },
    data() {
      this.chart.data.datasets[0].data = this.data
      this.chart.update()
    },
    colors() {
      this.chart.data.datasets[0].backgroundColor = this.colors
      this.chart.update()
    },
  },
  mounted() {
    const ctx = this.$refs.chartCanvas.getContext('2d')

    this.chart = new ChartJS(ctx, {
      type: 'doughnut',
      data: {
        labels: this.labels,
        datasets: [ {
          data: this.data,
          backgroundColor: this.colors,
          borderWidth: 3,
          borderColor: '#F1F4FC',
          borderRadius: 6,
          padding: 5,
        }, ],
      },
      options: {
        cutout: '50%',
        plugins: {
          legend: {
            display: false,
          },
          tooltip: {
            enabled: false,
          },
        },
      },
    })
  },
}
</script>

<style scoped>
.visit-chart {
  width: 120px;
  height: 120px;
  margin: 0 auto;
  position: relative;

  .percent {
    position: absolute;
    left: calc(53% - 24px);
    top: calc(51% - 15px);
    font-size: 19px;
    font-weight: 700;
    width: 44px;
    height: 32px;
    text-align: center;
    color: var(--primary);
  }
}
canvas {
  width: 100% !important;
}
</style>
